module.exports = __webpack_public_path__ + "img/91.5.COD.5f92d9ca.png";